/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --gap: var(--nve-ref-space-xs);
}

[internal-host] {
  display: flex;
  flex-direction: row;
  gap: var(--gap);
  overflow-x: auto;
  white-space: nowrap;
  scrollbar-color: var(--nve-sys-scrollbar-thumb-color) var(--nve-sys-scrollbar-track-color);
  scrollbar-width: var(--nve-sys-scrollbar-width);
}

:host([vertical]) {
  --gap: var(--nve-ref-space-xxxs);
}

:host([vertical]) [internal-host] {
  flex-direction: column;
}

:host([vertical]) ::slotted(nve-tabs-item) {
  --border-inset: 0 8px 0 8px;
  --width: calc(100% - 8px);
}

:host([vertical]) ::slotted(nve-tabs-item:state(selected)) {
  --nve-sys-interaction-state-ratio: var(--nve-sys-interaction-state-ratio-hover);
}

::slotted(nve-tabs-item) {
  white-space: nowrap;
}
